import React from "react";

const TeachersProfile = () => {
  return (
    <div className="container bg-gray-50">
      <div className="grid grid-cols-4 gap-5 p-10 ">
        <div className="  text-black-500 text-md font-bold text-center ">
          <div className="text-center pt-5 ">
            <img
              src="/assets/male.png"
              className="rounded-full w-32 h-32 mb-4 mx-auto"
              alt="Avatar"
            />
          </div>
          <div className="font-semibold grid  mt-2 ">
            <div className="  text-black-500 text-md font-bold text-center">
              <span>Experience </span>
            </div>
            <div className="  text-black-500 text-md  text-center">
              <span>4-5 year's</span>
            </div>
          </div>
          <div className="font-semibold grid  mt-2 ">
            <div className="  text-black-500 text-md font-bold text-center">
              <span>Teaching Subject </span>
            </div>
            <div className="  text-black-500 text-md  text-center">
              <span>English</span>
            </div>
          </div>
          <div className="font-semibold grid  mt-2 ">
            <div className="  text-black-500 text-md font-bold text-center">
              <span>Class Teacher</span>
            </div>
            <div className="  text-black-500 text-md  text-center">
              <span>10th 'A'</span>
            </div>
          </div>
        </div>
        <div className="  text-black-500 text-md col-span-3  ">
          <div className="grid grid-cols-3 pt-5">
            <div className=" grid grid-cols-3 ">
              <div className="rounded-sm ">
                <span className="block  font-bold">ID:</span>
              </div>
              <div className="text-left col-span-2">
                <span>AD62r3</span>
              </div>
            </div>
            <div className=" grid grid-cols-3 ">
              <div className="rounded-sm ">
                <span className="block  font-bold">Email ID:</span>
              </div>
              <div className="text-left col-span-2">
                <span>ashu@gmail.com</span>
              </div>
            </div>
            <div className=" grid grid-cols-3 ">
              <div className="rounded-sm ">
                <span className="block  font-bold">Joining:</span>
              </div>
              <div className="text-left col-span-2">
                <span>25/4/2022</span>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2  pl-5 pr-5 ">
            <div className="  text-black-500 text-lg font-bold text-center pt-10  ">
              <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Full Name
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <input
                      type="text"
                      placeholder="full Name"
                      className=" w-64  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                  </div>
                </div>
              </div>
              <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6 ">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Father's Name
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <input
                      type="text"
                      placeholder="Father's Name"
                      className=" w-64  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                  </div>
                </div>
              </div>
              <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      D.O.B
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <input
                      type="text"
                      placeholder="Date Of Birth"
                      className=" w-64  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                  </div>
                </div>
              </div>

              <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Martial Status
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <select
                      className="form-select 
      block
      w-64
      px-3
      py-1.5
      text-base
      font-normal
      text-gray-700
      bg-white bg-clip-padding bg-no-repeat
      border border-solid border-gray-300
      rounded
      transition
      ease-in-out
      m-0
      focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      aria-label="Default select example"
                    >
                      <option value="null"> Select </option>
                      <option value="1">married</option>
                      <option value="2">Unmarried</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Past Experience
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <input
                      type="text"
                      placeholder="Past Experience"
                      className=" w-64  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className=" text-black-500 text-lg font-bold text-center pt-10  pl-10 ">
              <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Qualification
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <input
                      type="text"
                      placeholder=" Higher Qualification"
                      className=" w-64  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                  </div>
                </div>
              </div>
              <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Mother's Name
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <input
                      type="text"
                      placeholder="Mother's Name"
                      className=" w-64  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                  </div>
                </div>
              </div>
              <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Gender
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <select
                      className="form-select 
      block
      w-64
      px-3
      py-1.5
      text-base
      font-normal
      text-gray-700
      bg-white bg-clip-padding bg-no-repeat
      border border-solid border-gray-300
      rounded
      transition
      ease-in-out
      m-0
      focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      aria-label="Default select example"
                    >
                      <option value="null"> select</option>
                      <option value="1">Male</option>
                      <option value="2">Female</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Contact No.
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <input
                      type="text"
                      placeholder="Contact No"
                      className=" w-64  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="pt-1 pl-5">
            <label
              className="block text-gray-500 font-bold md:text-left mb-1  "
              htmlFor="inline-full-name"
            >
              Skill's
            </label>
            <textarea
              type="text"
              placeholder=" Skill"
              className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            />
          </div>

          <div className="w-full p-5">
            <div className="mb-2 text-left ">
              <span className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4 text-xl">
                Permanent Address
              </span>
            </div>
            <div className="w-full">
              <div className=" w-full md:flex  md:items-center mb-6 ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Address Line 1:
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                    type="text"
                    placeholder=" Address Line 1"
                    className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  />
                </div>
              </div>
              <div className=" w-full md:flex  md:items-center mb-6 ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Address Line 2:
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                    type="text"
                    placeholder=" Address Line 2"
                    className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  />
                </div>
              </div>
              <div className=" w-full md:flex  md:items-center mb-6 ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Apartment
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                    type="text"
                    placeholder="  Apartment"
                    className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Zip Code
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <input
                      type="text"
                      placeholder="  Zip Code"
                      className=" w-32  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                  </div>
                </div>

                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      City
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <input
                      type="text"
                      placeholder=" City"
                      className=" w-32  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                  </div>
                </div>

                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      State
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <input
                      type="text"
                      placeholder=" State"
                      className=" w-32  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                  </div>
                </div>
              </div>
              <div className=" w-full md:flex  md:items-center ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Country
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                    type="text"
                    placeholder="  Country"
                    className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="w-full p-5">
            <div className="mb-2 text-left ">
              <span className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4 text-xl">
                Correspondence Address
              </span>
            </div>
            <div className="w-full">
              <div className=" w-full md:flex  md:items-center mb-6 ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Address Line 1:
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                    type="text"
                    placeholder=" Address Line 1"
                    className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  />
                </div>
              </div>
              <div className=" w-full md:flex  md:items-center mb-6 ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Address Line 2:
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                    type="text"
                    placeholder=" Address Line 2"
                    className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  />
                </div>
              </div>
              <div className=" w-full md:flex  md:items-center mb-6 ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Apartment
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                    type="text"
                    placeholder="  Apartment"
                    className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Zip Code
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <input
                      type="text"
                      placeholder="  Zip Code"
                      className=" w-32  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                  </div>
                </div>

                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      City
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <input
                      type="text"
                      placeholder=" City"
                      className=" w-32  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                  </div>
                </div>

                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-2/5">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      State
                    </label>
                  </div>
                  <div className="md:w-2/5">
                    <input
                      type="text"
                      placeholder=" State"
                      className=" w-32  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                  </div>
                </div>
              </div>
              <div className=" w-full md:flex  md:items-center ">
                <div className="mb-4 md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 "
                    htmlFor="inline-full-name"
                  >
                    Country
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                    type="text"
                    placeholder="  Country"
                    className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="text-center ease-in-out duration-300 ">
            <button className="  w-24 text-white text-xl h-10 text-center font-semibold rounded-md  bg-[#1273DE] hover:bg-[#117BEF] active:bg-[#117BEF] focus:outline-none focus:ring focus:ring-[#117BEF]">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeachersProfile;
